export default function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          精选专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          按类型精心整理的影视专题，一键获取完整片单
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {[
            {
              img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20costume%20scene%20with%20palace%20and%20lanterns%2C%20warm%20golden%20lighting%2C%20elegant%20ancient%20Chinese%20aesthetic%2C%20cinematic%20composition%2C%20rich%20colors%2C%20no%20text%20no%20people&width=800&height=500&seq=card-01-97&orientation=landscape',
              tag: '国剧推荐', title: '追剧清单：2025年必看国剧', desc: '从悬疑到古装，十部口碑炸裂的国产剧，每一部都值得细细品味。高清全集已收录。',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20city%20with%20flying%20vehicles%20and%20neon%20lights%2C%20cyberpunk%20aesthetic%2C%20dramatic%20cinematic%20lighting%20with%20warm%20gold%20and%20cool%20tones%2C%20film%20poster%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-02-97&orientation=landscape',
              tag: '科幻合集', title: '科幻迷的天堂：硬核科幻电影合集', desc: '从经典到新作，精选全球最值得看的科幻电影，蓝光画质带你遨游星辰大海。',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=mysterious%20foggy%20forest%20with%20old%20house%2C%20suspenseful%20thriller%20atmosphere%2C%20dark%20cinematic%20lighting%20with%20warm%20amber%20accents%2C%20noir%20aesthetic%2C%20film%20poster%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-03-97&orientation=landscape',
              tag: '悬疑精选', title: '周末电影马拉松：高分悬疑片单', desc: '反转再反转，全程无尿点。精选高分悬疑电影，让你的周末充满紧张刺激。',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=beautiful%20anime%20style%20sunset%20landscape%20with%20cherry%20blossoms%20and%20traditional%20Japanese%20temple%2C%20warm%20golden%20light%2C%20healing%20atmosphere%2C%20soft%20pastel%20colors%2C%20no%20text%20no%20people&width=800&height=500&seq=card-04-97&orientation=landscape',
              tag: '动漫精选', title: '动漫爱好者必看：年度最佳番剧', desc: '热血、治愈、奇幻、恋爱，各类高分动漫番剧一网打尽，追番指南。',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20cherry%20blossom%20street%20and%20warm%20evening%20light%2C%20elegant%20cinematic%20composition%2C%20soft%20golden%20and%20pink%20tones%2C%20drama%20poster%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-05-97&orientation=landscape',
              tag: '韩剧合集', title: '韩剧控的快乐：高分全集一次追完', desc: '从甜宠到复仇，精选高分韩剧全集，不用等更新一口气看到大结局。',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=action%20movie%20explosion%20scene%20with%20car%20chase%20on%20highway%2C%20dramatic%20cinematic%20lighting%2C%20warm%20orange%20fire%20and%20smoke%2C%20adrenaline%20action%20aesthetic%2C%20film%20poster%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-06-97&orientation=landscape',
              tag: '动作猛片', title: '动作片爱好者：肾上腺素飙升之选', desc: '枪战、格斗、飙车、爆炸，精选全球最刺激的动作猛片，热血沸腾停不下来。',
            },
          ].map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer">
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 text-xs font-medium text-background-50 bg-accent-500/90 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}